import { IAppState } from '../../../AppModulesWrapper';

import { BUSINESS_CENTER_CATEGORIES } from '../../constants/categories';

/**
 * @description Проверяет, выбрана ли категория "Аренда офиса в бизнес-центре".
 */
export function selectIsBusinessCenterCategory(state: IAppState): boolean {
  const { category, coworkingOfferType } = state.servicePickerWidget.offer;

  if (category === 'officeRent' && coworkingOfferType) {
    return false;
  }

  return BUSINESS_CENTER_CATEGORIES.includes(category);
}
